import React, { useEffect, useState } from 'react';
import { Alert, Box, FormControlLabel, Switch, Typography } from '@mui/material';
import api from '../../services/api';

// Avisos não essenciais por e-mail (documento pronto, créditos baixos, novidades).
// Verificação de conta, recuperação de senha, recibos e alertas de processo saem sempre.
const EmailNotificationsSetting: React.FC = () => {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.get('/users/me')
      .then(r => setEnabled(r.data.email_notifications !== false))
      .catch(() => setError('Não foi possível carregar sua preferência.'));
  }, []);

  const toggle = async (value: boolean) => {
    setSaving(true);
    setError(null);
    try {
      const r = await api.put('/users/me', { email_notifications: value });
      setEnabled(r.data.email_notifications !== false);
    } catch {
      setError('Não foi possível salvar. Tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Avisos por e-mail</Typography>
      <FormControlLabel
        control={<Switch checked={!!enabled} disabled={enabled === null || saving} onChange={e => toggle(e.target.checked)} />}
        label="Receber avisos por e-mail (documento pronto, créditos acabando e novidades)"
      />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        E-mails de verificação de conta, recuperação de senha, recibos de pagamento e os alertas de processos que você configurou continuam sendo enviados.
      </Typography>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </Box>
  );
};

export default EmailNotificationsSetting;
